import React from 'react';
import './WelcomeDialog.css';

const WelcomeDialog = ({ onClose }) => {
  const handleVisitDonLechuga = () => {
    window.open('https://garden.com.do/donlechuga.html', '_blank');
  };

  return (
    <div className="welcome-dialog-overlay">
      <div className="welcome-dialog-content">
        <button className="welcome-dialog-close" onClick={onClose} aria-label="Cerrar">
          ×
        </button>

        <img
          src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-2.svg'}
          alt="Logo Garden"
          className="welcome-dialog-logo"
        />

        <h1 className="welcome-dialog-title">
          Bienvenidos a Garden
        </h1>

        <p className="welcome-dialog-text">
          Descubre una nueva forma de vivir en Santiago, conectada con la naturaleza y la sostenibilidad.
        </p>

        <p className="welcome-dialog-text">
          <strong>Conoce a Don Lechuga</strong> y aprende sobre hidroponía en hogares modernos.
        </p>

        <div className="welcome-dialog-buttons">
          <button 
            className="welcome-dialog-btn welcome-dialog-btn-primary" 
            onClick={handleVisitDonLechuga}
          >
            Ver video con Don Lechuga
          </button>
          
          <button 
            className="welcome-dialog-btn welcome-dialog-btn-secondary" 
            onClick={onClose}
          >
            Comenzar tour virtual
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeDialog;
